<template>
  <!-- // Anfrage gesendet aber noch nicht angnommen >>> Anfrage abbrechen Button -->
  <v-btn
    v-if="myFriends.some(friend => friend.friendId === item.id && friend.acceptedByFriend === false && friend.acceptedByUser === true)"
    fab
    class="mx-1"
                    
    small
    color="white"
    @click="cancelRequest(item.id)">
    <v-icon small>
      fas fa-user-times
    </v-icon>
  </v-btn>

  <!-- // Anfrage gesendet und angenommen  -->
  <v-speed-dial
    v-else-if="myFriends.some(friend => friend.friendId === item.id && friend.acceptedByFriend === true && friend.acceptedByUser === true)"
    v-model="fab"
    direction="left"
    transition="slide-x-reverse-transition">
    <v-btn
      slot="activator"
      v-model="fab"
      fab
      depressed
                   
                    
      :ripple="false"
      color="white"

      class="mx-1"
      small>
      <v-icon small>
        fas fa-user-check
      </v-icon>
      <v-icon small>
        fas fa-times
      </v-icon>
    </v-btn>
                             
    <v-btn
      fab
      class="mx-1"
      dark
      small
      color="red"
      @click="cancelRequest(item.id)">
      <v-icon small>
        fas fa-user-minus
      </v-icon>
    </v-btn>
  </v-speed-dial>



                 


  <!-- // Neue Anfrage von Friend gesendet aber noch nicht angenommen  -->

  <v-speed-dial
    v-else-if="myFriends.some(friend => friend.friendId === item.id && friend.acceptedByFriend === true && friend.acceptedByUser === false)"
    v-model="fab"
    direction="left"
    transition="slide-x-reverse-transition">
    <v-btn
      slot="activator"
      v-model="fab"

      class="mx-1"
      small
      color="blue darken-1"
      dark
      fab>
      <v-icon small>
        fas fa-user-tag
      </v-icon>
      <v-icon small>
        fas fa-times
      </v-icon>
    </v-btn>
                    
          
    <v-btn
      fab
      class="mx-1"
          

      dark
      small
      color="red"
      @click="cancelRequest(item.id)">
      <v-icon small>
        fas fa-user-times
      </v-icon>
    </v-btn>

    <v-btn
      fab
      class="mx-1"
      dark
      small
      color="green"
      @click="acceptRequest(item)">
      <v-icon small>
        fas fa-user-check
      </v-icon>
    </v-btn>
  </v-speed-dial>



  <!-- // Kein Anfrage vorhanden  -->
 
  <v-btn
    v-else-if="item.id !== user.id"
    fab
    class="mx-1"
    dark
    small
    color="green"
    @click="addNewFriend(item)">
    <v-icon small>
      fas fa-user-plus
    </v-icon>
  </v-btn>
</template>


<script>
import { debounce } from 'lodash'
import { mapActions } from 'vuex'


export default {
  props: {
    item: { 
      type: Object,
      default: null
    },
    myFriends: { 
      type: Array,
      default: null
    },
    user: { 
      type: Object, 
      default: null
    },
  },
  data () {
    return {
      fab: false,
    }
  },
  computed: {
    debounceAddNewFriends (val) {
      // console.log('I only get fired once every three seconds, max!', val)
      return debounce(this.addNewFriendsFirebase, 1000, {leading: true})
    }
  },
  methods: {

    ...mapActions([
      'addNewFriendsFirebase',
      'acceptFriendRequest',
      'cancelFriendRequest',
    ]),

    
    // Start friend request 
    addNewFriend(item) {
      console.log('start', item)
      
      this.debounceAddNewFriends(item)
    },

    // Cancel friend request 
    cancelRequest(id) {
      console.log('startCancelRequest', id)
      console.log(this.user)
      this.cancelFriendRequest(id)
    },

    acceptRequest(item) {
      
      var index = this.myFriends.findIndex(friend => friend.friendId === item.id)
      var notificationId = this.myFriends[index].notificationId

      var payload = {
        friendId: item.id,
        acceptedByFriend: true,
        acceptedByUser: true,
        requester: this.user.uid,
        friendName: item.name,
        friendProfileImg: item.profileImg,
        friendStatus: item.status,
        notificationId: notificationId,
        uniqueId: item.uniqueId
      }
      this.acceptFriendRequest(payload)
    }
  },
 
}
</script>
